export const transformGraphqlResponse = (response: any) => {
  if (response?.errors?.length || !response?.data) {
    throw new Error('Something went wrong');
  }

  return response.data;
};
